import React, { createContext, useContext, useState } from "react";

const DonateContext = createContext(null);

export const DonateProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <DonateContext.Provider value={{ open, openDonate: () => setOpen(true), setOpen }}>
      {children}
    </DonateContext.Provider>
  );
};

export const useDonate = () => useContext(DonateContext);
